import styles from "./CloseButton.module.css";

const CloseButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className={styles.btn} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
      >
        <path
          d="M22.0001 20.2223L28.2222 14L30 15.7778L23.7778 22.0001L30 28.2222L28.2222 30L22.0001 23.7778L15.7778 30L14 28.2222L20.2223 22.0001L14 15.7778L15.7778 14L22.0001 20.2223Z"
          fill="#fff"
        />
        <rect
          x="0.916667"
          y="0.916667"
          width="42.1667"
          height="42.1667"
          rx="3.08333"
          stroke="#fff"
          strokeWidth="1"
        />
      </svg>
    </div>
  );
};

export default CloseButton;
